import { ThunkAction } from 'redux-thunk';
import { AxiosResponse } from 'axios';
import store from 'store';
import ApiClient, { createTokenConfig, isCancelled } from 'api/ApiClient';
import { NotificationsAction, showError } from '@spike/notifications-action';

import {
    SALES_BY_CATEGORY_REPORT_GET_START,
    SALES_BY_CATEGORY_REPORT_GET_SUCCESS,
    SALES_BY_CATEGORY_REPORT_GET_ERROR,
    SalesByCategoryReportAction
} from './SalesByCategoryReportActionsType';

import { SalesByCategoryReportDto } from './SalesByCategoryReportDto';
import { convertToSalesByCategoryReport } from './salesByCategoryReportConverter';
import { SalesByCategoryReport } from 'model/SalesByCategoryReport';

export const getSalesByCategoryReport = (
    start?: string,
    end?: string
): ThunkAction<void, null, null, SalesByCategoryReportAction | NotificationsAction> => {
    return async dispatch => {
        dispatch(getStart());

        const { marketplaceId, timeZone } = store.getState().login.auth;

        let url = `/sales_by_category_report?marketplace_id=${marketplaceId}`;
        if (start) url += `&start=${start}`;
        if (end) url += `&end=${end}`;

        try {
            const response: AxiosResponse<SalesByCategoryReportDto> = await ApiClient.get(
                url,
                createTokenConfig(store.getState().login.auth.token!)
            );

            dispatch(getSuccess(convertToSalesByCategoryReport(response.data)));
        } catch (apiError) {
            if (!isCancelled(apiError)) {
                dispatch(getError());
                dispatch(showError('Too many records to display. Please try a shorter date range.'));
            }
        }
    };
};

const getStart = (): SalesByCategoryReportAction => ({
    type: SALES_BY_CATEGORY_REPORT_GET_START
});

const getSuccess = (report: SalesByCategoryReport): SalesByCategoryReportAction => ({
    type: SALES_BY_CATEGORY_REPORT_GET_SUCCESS,
    payload: { report }
});

const getError = (): SalesByCategoryReportAction => ({
    type: SALES_BY_CATEGORY_REPORT_GET_ERROR
});
